import {lazy} from '@aboutyou/lazy-imports';

/**
 *
 * @param props
 * @returns
 * @deprecated shall be removed once coins is live
 */
export const WalletBody = lazy(() =>
  import('./WalletBody.eager').then(mod => ({
    default: mod.WalletBody,
  })),
);
